export default "__VITE_ASSET__DeOcsDkc__"